import {Observable, Subject} from "rxjs";
import {shareReplay, takeUntil} from "rxjs/operators";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class WizardEventsService {

    private save$ = new Subject<void>();
    private doneSave$ = new Subject<any>();
    private nextOrSave$ = new Subject<any>();
    private gotoFinish$ = new Subject<any>();
    private destroy$ = new Subject();
    private goToStep$ = new Subject<number>();
    private goToStepName$ = new Subject<string>();
    private _arrowsState$ = new Subject<boolean>();
    private setReadOnly$ = new Subject<any>();
    private generateFolio$ = new Subject<any>();
    private error$ = new Subject<any>();
    public readOnly = this.setReadOnly$.asObservable().pipe(shareReplay(1));

    constructor() {
    }

    get onSave(): Observable<void> {
        return this.save$.asObservable().pipe(takeUntil(this.destroy$));
    }

    stopSubscriptions() {
        this.destroy$.next();
    }

    save() {
        this.save$.next();
    }

    doneSave(val: any, pasoGuardar: any) {
        const obj = {};
        obj['wizardSteps'] = val;
        obj['origen'] = pasoGuardar;
        this.doneSave$.next(obj);
    }

    get onDoneSave(): Observable<any> {
        return this.doneSave$;
    }

    error(error: any) {
        this.error$.next(error);
    }

    get onError(): Observable<any> {
        return this.error$;
    }

    nextOrSave(val: any) {
        this.nextOrSave$.next(val);
    }

    get onNextOrSave(): Observable<any> {
        return this.nextOrSave$;
    }

    goToFinish() {
        this.gotoFinish$.next();
    }

    get goToFinishEvent(): Observable<any> {
        return this.gotoFinish$;
    }

    gotToStepName(name: string){
        this.goToStepName$.next(name);
    }
    goToStep(stepNumber: number) {
        this.goToStep$.next(stepNumber);
    }

    get goToStepEvent(): Observable<any> {
        return this.goToStep$;
    }
    get goToStepNameEvent(): Observable<string> {
        return this.goToStepName$.asObservable();
    }

    changeArrowState(show: boolean) {
        this._arrowsState$.next(show);
    }

    get arrowsState$(): Subject<boolean> {
        return this._arrowsState$;
    }

    setReadOnly(val: any) {
        this.setReadOnly$.next(val);
    }

    get setReadOnlyEvent(): Observable<any> {
        return this.setReadOnly$;
    }

    generateFolio(val: any) {
        this.generateFolio$.next(val);
    }

    get onGenerateFolio(): Observable<any> {
        return this.generateFolio$;
    }
}


